import EmailTemplate from ".";

export const emailRoutes = (data) => [
  {
    path: "/admin/email-template",
    title: "plans",
    layout: "admin",
    routeType: "admin",
    component: EmailTemplate,
  },
];
